import React from 'react'

export const CodeBlockIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="graphic code-block-icon"
    focusable="false"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="stroke"
      d="M14 12.6667L16.6667 9.99999L14 7.33332M5.99999 7.33332L3.33333 9.99999L5.99999 12.6667M11.6667 4.66666L8.33333 15.3333"
      strokeLinecap="square"
    />
  </svg>
)
